import { render, staticRenderFns } from "./PortfolioOrdering.vue?vue&type=template&id=b3a4d20e&"
import script from "./PortfolioOrdering.vue?vue&type=script&lang=js&"
export * from "./PortfolioOrdering.vue?vue&type=script&lang=js&"
import style0 from "./PortfolioOrdering.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PortfolioOrdering.vue"
export default component.exports